export default __webpack_public_path__ + "static/media/completedInvoice.ca5253e7.svg";